import type { SelectorOption } from '../Components';

export const fullbleedSourceDocuments: SelectorOption[] = [
    {
        label: 'Sample document 1',
        value: 'https://storage.documents.cimpress.io/v3/documents/6c461b13-69e8-462a-98e8-24ccbd529cf0/revisions/72415e3a-c6f2-4813-ace0-29b488d6d43e',
    },
    {
        label: 'Sample document 2',
        value: 'https://storage.documents.cimpress.io/v3/documents/56b54064-02f1-41d4-9f27-e112b70d2492/revisions/38f68e15-c2f2-4ee0-ad00-54b84bf4ce23',
    },
    {
        label: 'Photo fullbleed document - 1',
        value: 'https://storage.documents.cimpress.io/v3/documents/ce37cefe-c27b-469c-99c4-fdb4848a251c~300/revisions/0e9a8ea5-5384-4684-bf88-3b2a5330b769~300',
    },
    {
        label: 'Photo fullbleed document - 2',
        value: 'https://storage.documents.cimpress.io/v3/documents/ce37cefe-c27b-469c-99c4-fdb4848a251c~300/revisions/3c5ff131-cf3a-486b-b349-31cc61f27d87~300',
    },
];
